// @vendors
const Immutable = require('immutable');
const moment = require('moment');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    simulation: {
        amount: 0,
        clientRiskProfile: null /*{
            clientRiskProfileDescription: null,
            clientRiskProfileValue: null
        }*/,
        currency: 'EUR',
        endDate: null,
        hasRecurringTransfer: false,
        initialContribution: null,
        id: null,
        maxTypeOfProduct: null,
        name: '',
        displayName: '',
        recurringTransfer: null /*{
            amount: null,
            cutDay: null,
            frequencyCode: null
        },*/,
        selectedPortfolio: null,
        type: null,
    },
    isFetching: false,
    success: false,
    error: false,
});

const getValidEndOfDate = endDate => {
    if (!endDate || moment(endDate) < moment().add(1, 'years')) {
        return null;
    }
    return endDate;
};

const RASimulation = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_MANAGEMENT_PLAN_RESET:
            return initialState;
        case actionTypes.RA_SIMULATION_REQUEST:
            return state.merge({
                isFetching: true,
                success: false,
                error: false,
            });
        case actionTypes.RA_SIMULATION_REQUEST_FAILURE:
            return state.merge({
                isFetching: false,
                success: true,
                error: true,
                simulation: initialState.get('simulation'),
            });
        case actionTypes.RA_SIMULATION_REQUEST_SUCCESS:
            return state.merge({
                isFetching: false,
                success: true,
                error: false,
                simulation: {
                    amount: action.payload.amount,
                    clientRiskProfile: action.payload.clientRiskProfile,
                    currency: action.payload.currency,
                    endDate: getValidEndOfDate(action.payload.endDate),
                    hasRecurringTransfer: action.payload.hasRecurringTransfer,
                    initialContribution: action.payload.initialContribution,
                    id: action.payload.id,
                    maxTypeOfProduct: action.payload.maxTypeOfProduct,
                    name: action.payload.name,
                    displayName: action.payload.displayName,
                    recurringTransfer: action.payload.recurringTransfer,
                    selectedPortfolio: action.payload.selectedPortfolio,
                    type:
                        action.payload.type &&
                        action.payload.type.toLowerCase(),
                },
            });
        case actionTypes.RA_SIMULATION_UPDATE_SIMULATION:
            return state.mergeDeepIn(['simulation'], action.payload);
        case actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET:
            return initialState;
        default:
            return state;
    }
};

module.exports = RASimulation;
